import React, { useState } from 'react';
import { NavBar, Toast } from 'antd-mobile';
import {Outlet, useNavigate} from "react-router-dom";
import TransportMenuDrawer from "../components/TransportMenuDrawer";
import { getNavBarContainerStyle } from '../../../utils/deviceUtils';
import PickUpMenuIconWithBadge from "../../pickup/components/PickUpMenuIconWithBadge";
import WayPointMenuIconWithBadge from "../components/WayPointMenuIconWithBadge";
import {PickUpItem, PickUpPathNavigationTabBar} from "../../pickup/components/PickUpPathNavigationTabBar";
import {TruckOutline} from "antd-mobile-icons";
import {t} from "../../../i18n";
import {TmsPath} from "../../../enums/TmsNavigatePathEnum";
import {MapModeIcon} from "../../../assets/icons";
import {TmsPathPre} from "../../../enums/TmsNavigatePathEnum";
import { useTmsTaskWaypointList } from "../store/transportStore";

type WayPointLayoutProps = {
    children?: React.ReactNode;
    title: string;
}

const transportItems: PickUpItem[] = [
    {
        path: TmsPath.TMS_TRANSPORTING,
        icon: <TruckOutline/>,
        label: `${t('pages.itemTransport')}`
    }
]

const TransportLayout: React.FC<WayPointLayoutProps> = ({ children, title }) => {
    const [menuVisible, setMenuVisible] = useState(false);

    const [failedCount, setFailedCount] = useState<number>(0);
    const navigate = useNavigate();
    const { tmsTaskWaypointList } = useTmsTaskWaypointList();

    const handleOpenMenu = () => setMenuVisible(true);
    const handleCloseMenu = () => setMenuVisible(false);

    const handleExceptionReport = () => {
        // 从 transportingWayPointDataList 第一条获取 taskId
        const firstWaypoint = tmsTaskWaypointList?.[0];
        const taskId = firstWaypoint?.taskId;

        if (!taskId) {
            Toast.show({
                content: t('pages.tms.transporting.noOngoingTask'),
                position: 'center'
            });
            return;
        }

        navigate(TmsPathPre.TMS_TRANSPORTING_EXCEPTION_PRE + String(taskId));
    };

    return (
        <div className="flex flex-col h-screen bg-gray-50 overflow-hidden">
            <TransportMenuDrawer
                visible={menuVisible}
                onClose={handleCloseMenu} />
            {/* 顶部导航栏 */}
            <div {...getNavBarContainerStyle('flex-none sticky top-0 z-10 bg-white shadow-sm')}>
                <NavBar
                    backIcon={<WayPointMenuIconWithBadge count={failedCount}/>}
                    onBack={handleOpenMenu}
                    right={<div
                        className="flex items-center justify-end w-full text-red-500 font-bold cursor-pointer text-base"
                        onClick={handleExceptionReport}
                    >
                        {t('pages.tms.transporting.exceptionReport')}
                    </div>}
                >
                </NavBar>
            </div>

            {/* 内容区域 */}
            <div id="tms-main-container" className="flex-1 overflow-y-auto">
                {children|| <Outlet/>}
            </div>

            {/* 底部导航 - 固定 */}
            <div className="flex-none sticky bottom-0 z-10 bg-white border-t border-gray-200">
                <PickUpPathNavigationTabBar items={transportItems}/>
            </div>
        </div>
    );
};

export default TransportLayout;


